// box-store.js — window.allplants.box
// Client-side "build a box" selection, persisted in localStorage. Meals are NOT
// added to the Shopify cart here; the box is a pending selection. Only at
// checkout does <box-builder> flush the whole box into the cart in one request.
//
// Shape (per box key):  { items: { "<variantId>": { quantity, image, title, price, points, handle } },
//                         attributes: { "Delivery Date": "…" } }
//
// items() returns an array shaped like Shopify cart line items (variant_id, id,
// quantity, image, …) so the box builder's render code consumes it unchanged.
//
// Broadcasts `box:updated` on document with detail { boxKey, box } after every
// mutation, so any listening component re-renders.
window.allplants = window.allplants || {};

(function () {
  const PREFIX = "allplants:box:";
  const DEFAULT_KEY = "build-a-box";
  const empty = () => ({ items: {}, attributes: {} });

  const read = (boxKey) => {
    try {
      return JSON.parse(localStorage.getItem(PREFIX + boxKey)) || empty();
    } catch (e) {
      return empty();
    }
  };
  const write = (boxKey, state) => {
    try {
      localStorage.setItem(PREFIX + boxKey, JSON.stringify(state));
    } catch (e) {
      /* storage full / disabled — box just won't persist */
    }
  };

  const store = {
    state(boxKey = DEFAULT_KEY) {
      return read(boxKey);
    },

    // Cart-line-item-shaped array so existing render code needs no changes.
    items(boxKey = DEFAULT_KEY) {
      const { items } = read(boxKey);
      return Object.keys(items).map((id) => {
        const entry = items[id];
        return {
          variant_id: Number(id),
          id: Number(id),
          quantity: entry.quantity,
          image: entry.image || "",
          title: entry.title || "",
          price: entry.price || 0,
          points: entry.points || 0,
          handle: entry.handle || "",
        };
      });
    },

    count(boxKey = DEFAULT_KEY) {
      const { items } = read(boxKey);
      return Object.keys(items).reduce((s, id) => s + items[id].quantity, 0);
    },

    // Relative change. `meta` (image/title/price/points/handle) is recorded so a
    // meal added from one page renders correctly on another that lacks its card.
    change(boxKey, variantId, delta, meta) {
      const state = read(boxKey);
      const id = String(variantId);
      const entry = state.items[id] || { quantity: 0 };
      entry.quantity += delta;
      if (meta) {
        ["image", "title", "price", "points", "handle"].forEach((k) => {
          if (meta[k] != null) entry[k] = meta[k];
        });
      }
      if (entry.quantity > 0) state.items[id] = entry;
      else delete state.items[id];
      write(boxKey, state);
      this._emit(boxKey, state);
      return state;
    },

    setAttribute(boxKey, name, value) {
      const state = read(boxKey);
      state.attributes[name] = value;
      write(boxKey, state);
      this._emit(boxKey, state);
    },

    clear(boxKey = DEFAULT_KEY) {
      const state = empty();
      write(boxKey, state);
      this._emit(boxKey, state);
    },

    _emit(boxKey, state) {
      document.dispatchEvent(
        new CustomEvent("box:updated", {
          bubbles: true,
          detail: { boxKey: boxKey, box: state },
        })
      );
    },
  };

  window.allplants.box = window.allplants.box || store;
})();
